import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=70ed6812"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ed6812')) {
      api.createRecord('70ed6812', component.options)
    } else {
      api.reload('70ed6812', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=70ed6812", function () {
      api.rerender('70ed6812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/PRESTAMA/Form2_Persona.vue"
export default component.exports